import { Search } from '@mui/icons-material';
import { Box, TextField, InputAdornment, IconButton, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

interface FilterFieldProps {
  setFilter: (filter: string) => void;
}
export const FilterField = (props: FilterFieldProps) => {
  const { setFilter } = props;
  const usePalette = useTheme().palette;
  const theme = useTheme();
  const intl = useIntl();
  return (
    <Box borderRadius={0.5} margin={1}>
      <Box  >
        <TextField
          type="search"
          variant="outlined"
          fullWidth
          InputProps={{
            style: {...theme.typography.body2},
            placeholder: intl.formatMessage({
              id: 'FilterField'
            }),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
            sx: {
              backgroundColor: usePalette.background.paper, borderColor: usePalette.primary.dark, fontWeight: '400'
            }
          }}
          onChange={(e) => setFilter(e.target.value)}
        />
      </Box>
    </Box>
  );
};
